import React from "react";
import "./ProjectCard.scss";

export interface Project {
  logo: string;
  title: string;
  description: string;
  url: string;
  tags: string[];
}

interface ProjectCardProps {
  project: Project;
}

const ProjectCard: React.FC<ProjectCardProps> = ({ project }) => {
  return (
    <a
      href={project.url}
      target="_blank"
      rel="noopener noreferrer"
      className="project-card"
    >
      {project.logo && (
        <div className="logo-container">
          <img
            src={project.logo}
            alt={`${project.title} Logo`}
            className="logo"
          />
        </div>
      )}
      <div className="details">
        <h3 className="title">{project.title}</h3>
        <p className="description">{project.description}</p>

        <div className="tags">
          {project.tags.map((tag) => (
            <span className="tag" key={tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>
    </a>
  );
};

export default ProjectCard;
